@use '@shared/styles/media' as media;
@use '@shared/styles/general' as general;

$border-radius: 0.5rem;

.disabling-wrapper {
  display: none;
}

.modal-form-wrapper {
  border-radius: $border-radius;

  &-close-bg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &__icon {
      position: absolute;
      top: 0.5rem;
      right: 1rem;
      transition: 0.3s;

      svg {
        path {
          fill: var(--tg-theme-text-color);
        }
      }

      &:hover {
        cursor: pointer;
        opacity: 50%;
      }
    }
  }
}

.modal-form {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  max-width: 100vw;
  padding: 2.5rem 2.25rem;
  border-radius: $border-radius;
  background-color: var(--tg-theme-bg-color);
  overflow: hidden;
  z-index: 1;

  &_absolute {
    position: absolute;
  }

  &_priority {
    z-index: 3;
  }

  &__title {
    margin-bottom: 1.5rem;
    font-size: 1.5rem;
  }

  &__content {
    width: 100%;

    iframe {
      width: 80vw;
    }
  }

  &__buttons {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 1.5rem;

    // button {
    //   margin-top: 1.5rem;
    // }
  }
}

//
//
//
//
//
//

.modal-form_default {
  // width: auto;
  width: 26rem;
  padding: 1.5rem 1.75rem;
  background-color: var(--tg-theme-bg-color);
}

.modal-form_default-no-overflow {
  width: 26rem;
  padding: 1.5rem 1.75rem;
  background-color: var(--tg-theme-bg-color);
  overflow: visible;
}

.modal-form_ot {
  margin: 0 auto;
  width: 95%;
  min-width: 75rem;
  min-height: 29rem;
  padding: 1.5rem 1.75rem;
  background-color: var(--tg-theme-bg-color);
  overflow: visible;
  overflow-y: auto;

  svg {
    path {
      fill: var(--tg-theme-text-color);
    }
  }

  @include general.custom-scrollbar(0.5rem);
}

.modal-form_white {
  width: 26rem;
  padding: 1.5rem 1.75rem;
  background-color: var(--tg-theme-bg-color);
}

.modal-form_transparent {
  width: auto;
  padding: 1rem;
  background-color: transparent;
}

.modal-form_contact {
  width: 45rem;
  padding: 1.5rem 1.75rem;
  background-color: var(--tg-theme-bg-color);
}

.modal-form_invest-contact {
  width: 90rem;
  padding: 1.5rem 1.75rem;
  background-color: var(--tg-theme-bg-color);
}

// .modal-form_login {
//   width: 26rem;
//   padding: 1.75rem 1.75rem;
//   background-color: var(--tg-theme-bg-color);
// }

.modal-form_quick-search {
  width: 44rem;
  max-height: 80vh;
  padding: 1rem 0;
  border-radius: 0.5rem;
  overflow: visible;
  overflow-y: auto;
  border: 1px solid var(--tg-theme-hint-color);
  background-color: var(--tg-theme-bg-color);

  @include general.custom-scrollbar(0.5rem);
}

.modal-form_search {
  width: 36rem;
  max-height: 80vh;
  padding: 1rem 0;
  border-radius: 0.5rem;
  overflow: visible;
  overflow-y: auto;
  border: 1px solid var(--tg-theme-hint-color);
  background-color: var(--tg-theme-bg-color);

  @include general.custom-scrollbar(0.5rem);
}

.modal-form_ticker-additional-info {
  width: 24rem;
  padding: 1rem;
  border-radius: 1rem;
  overflow: visible;
}

.modal-form_portfolios {
  width: 20rem;
  max-height: 26rem;
  padding: 1rem;
  border-radius: 1rem;
  overflow-y: auto;
  border: 1px solid var(--tg-theme-hint-color);
  background-color: var(--tg-theme-bg-color);
}

.modal-form_watchlists {
  width: 20rem;
  max-height: 26rem;
  padding: 1rem;
  border-radius: 1rem;
  overflow-y: auto;
  border: 1px solid var(--tg-theme-hint-color);
  background-color: var(--tg-theme-bg-color);
}

.modal-form_select-image {
  width: 45vw;
  padding: 1rem;
  border-radius: 1rem;
  overflow: visible;
  border: 1px solid var(--tg-theme-hint-color);
  background-color: var(--tg-theme-bg-color);
}

.modal-form_share {
  padding: 1rem;
}

//
//
//
//
//
//

// TODO replace iframe with needed class !

@media (min-width: media.$minWidthPhone) {
  .modal-form {
    &__content {
      iframe {
        width: 80vw;
        height: 40vh;
      }
    }
  }
}

@media (min-width: media.$minWidthTablet) {
  .modal-form {
    &__content {
      iframe {
        width: 70vw;
        height: 50vh;
      }
    }
  }
}

@media (min-width: media.$minWidthDesktopExtraLarge) {
  .modal-form {
    &__content {
      iframe {
        width: 70vw;
        height: 70vh;
      }
    }
  }
}

@media (min-width: media.$minWidthDesktopExtraLargePlus) {
  .modal-form {
    &__content {
      iframe {
        width: 60vw;
        height: 70vh;
      }
    }
  }
}

@media (max-width: media.$minWidthPhoneMiddle) {
  .modal-form_select-image {
    width: 100vh;
  }
}
